import { useEffect, type ReactNode } from "react";
import type { SocietyTheme } from "shared/mappers/database/society/theme";

interface ThemeProviderProps {
  theme?: SocietyTheme[];
  children: ReactNode;
}

export const ThemeProvider = ({ theme, children }: ThemeProviderProps) => {
  useEffect(() => {
    if (theme) {
      theme.forEach((item: SocietyTheme) => {
        document.documentElement.style.setProperty(
          `--${item.property}`,
          item.value,
        );
      });

      return () => {
        theme.forEach((item: SocietyTheme) => {
          document.documentElement.style.removeProperty(`--${item.property}`);
        });
      };
    }
  }, [theme]);

  return <>{children}</>;
};
